import {Injectable} from '@angular/core';
import {IntegrationData} from "../models/integration-data";
import {Observable, of} from "rxjs";
import {IntegrationInputData} from "../models/Integration-input-data";

@Injectable({
    providedIn: 'root'
})
export class IntegrationService {

  isStarted(data: IntegrationData) {
        // WebappInterface can be undefined if not integrated in Android WebView.
        if (typeof WebappInterface !== 'undefined') {
            WebappInterface.onStarted(JSON.stringify(data));
        }
        (window as any).webkit?.messageHandlers?.onStarted?.postMessage(data);
        parent.postMessage({type: 'onStarted', data}, '*');
        (window as any).ReactNativeWebView?.postMessage(JSON.stringify({type: 'onStarted', data}))
    }

    isFinished(data: IntegrationData) {
        // WebappInterface can be undefined if not integrated in Android WebView.
        if (typeof WebappInterface !== 'undefined') {
            WebappInterface.onFinished(JSON.stringify(data));
        }
        (window as any).webkit?.messageHandlers?.onFinished?.postMessage(data);
        parent.postMessage({type: 'onFinished', data}, '*');
        (window as any).ReactNativeWebView?.postMessage(JSON.stringify({type: 'onFinished', data}))

    }

    onError(data: IntegrationData) {
        if (typeof WebappInterface !== 'undefined') {
            WebappInterface.onError(JSON.stringify(data));
        }
        (window as any).webkit?.messageHandlers?.onError?.postMessage(data);
        parent.postMessage({type: 'onError', data}, '*');
        (window as any).ReactNativeWebView?.postMessage(JSON.stringify({type: 'onError', data}))
    }

}


